import { FlexBox } from 'shared/components/Base/FlexBox'
import { Text } from 'shared/components/Text/Text'
import { darkGray } from 'shared/theme/colors'

import { JobStatusDetail } from '../../../helpers/constants'
import { Job } from '../../../models/jobs'
import { CustomReferenceField } from '../../Common/CustomReferenceFields'

interface JobDetailsStatusDetailV2Props {
  job: Job
  classes?: any
}

// TODO: @public-console-job-details-redesign
// Show if status is aborted / cancellation requested / cancelled
// TBD: show if recovery is needed
export function JobDetailsStatusDetailV2({ job }: JobDetailsStatusDetailV2Props) {
  return (
    <FlexBox isColumn gap="6px">
      <FlexBox justifyContent="space-between" alignItems="center">
        {job?.status_detail === JobStatusDetail.Recovered && (
          <CustomReferenceField
            record={job}
            source="recovery_job"
            sortable={false}
            label="Recovery Job"
            baseUrl="/jobs"
            representationFunction={() => job?.recovery_job?.human_id}
          />
        )}
      </FlexBox>
      {job?.abort_reason && (
        <Text variant="label3" fontColor={darkGray}>
          Abort reason: {job?.abort_reason}
        </Text>
      )}
      {job?.abort_cancel_detail && (
        <Text variant="label3" fontColor={darkGray}>
          Abort description: {job?.abort_cancel_detail}
        </Text>
      )}

      {job?.status_detail === JobStatusDetail.Canceled && (
        <Text variant="label3" fontColor={darkGray}>
          Cancel reason: {job?.cancel_reason}
        </Text>
      )}
      {job?.status_detail === JobStatusDetail.RequestedCancellation && (
        <>
          <Text variant="label3" fontColor={darkGray}>
            Request reason: {job?.cancel_request_reason}
          </Text>
          <Text variant="label3" fontColor={darkGray}>
            Description: {job?.cancel_request_detail}
          </Text>
        </>
      )}
    </FlexBox>
  )
}
